var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 17H31.6727C29.7998 17 28.8634 17 28.0448 16.7064C27.3213 16.4469 26.6673 16.0241 26.1338 15.4707C25.5302 14.8448 25.1459 13.9908 24.3773 12.2829L24.1227 11.7171C23.3541 10.0092 22.9698 9.1552 22.3662 8.52926C21.8327 7.97594 21.1787 7.5531 20.4552 7.29358C19.6366 7 18.7002 7 16.8273 7H14.5C13.1066 7 12.4099 7 11.8262 7.08659C8.34051 7.60364 5.60364 10.3405 5.08659 13.8262C5 14.4099 5 15.1066 5 16.5V28.2C5 32.6804 5 34.9206 5.87195 36.6319C6.63893 38.1372 7.86278 39.3611 9.36808 40.1281C11.0794 41 13.3196 41 17.8 41H24M43 25V21.5C43 17.3024 43 15.2035 42.2319 13.5796C41.4406 11.9064 40.0936 10.5594 38.4204 9.76809C36.7965 9 34.6976 9 30.5 9",
    stroke: "#202124",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9408 27.2901C35.9539 27.2256 36.0461 27.2256 36.0593 27.2901C36.7438 30.6391 39.361 33.2562 42.71 33.9408C42.7745 33.9539 42.7745 34.0461 42.71 34.0593C39.361 34.7438 36.7438 37.361 36.0593 40.71C36.0461 40.7745 35.9539 40.7745 35.9408 40.71C35.2562 37.361 32.6391 34.7438 29.2901 34.0593C29.2256 34.0461 29.2256 33.9539 29.2901 33.9408C32.6391 33.2562 35.2562 30.6391 35.9408 27.2901Z",
    stroke: "#5200FF",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3438 23.211C23.4898 22.4967 24.5104 22.4967 24.6564 23.211C24.9788 24.7886 26.2117 26.0214 27.7892 26.3438C28.5035 26.4898 28.5035 27.5104 27.7892 27.6564C26.2117 27.9788 24.9788 29.2117 24.6564 30.7892C24.5104 31.5035 23.4898 31.5035 23.3438 30.7892C23.0214 29.2117 21.7886 27.9788 20.211 27.6564C19.4967 27.5104 19.4967 26.4898 20.211 26.3438C21.7886 26.0214 23.0214 24.7886 23.3438 23.211Z",
    fill: "#5200FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/home-icon.bb81702c1e6b0768a32ded6485e9eb26.svg";
export { ForwardRef as ReactComponent };